import Vue from 'vue'

const CATEGORY = {
	LIST: filter => {
		return Vue.$api.get('/categories', { params: { filter: filter } })
	},

	DELETE: id => {
		return Vue.$api.delete('/categories/' + id)
	},

	CREATE: ({ code, isMainCategory, orgId }) => {
		return Vue.$api.post('/categories', { code, isMainCategory, orgId })
	},
}

export default CATEGORY
